let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gQpFC")).then(() => parcelRequire('1YxvO'));